import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEResidenceHistoriesCardActions = {
  initPeResidenceHistoriesCard: ({ commit }, index) => {
    commit('setPeResidenceHistoriesCardLock', { index, lock: true })
  },
  peResidenceHistoriesMultipleCardCreate: async ({ dispatch }, sections) => {
    return sections.reduce((acc, section) => {
      if (acc) return acc.then(_ => dispatch('peResidenceHistoriesCardCreate', { section, index: 'new' }))
      else return dispatch('peResidenceHistoriesCardCreate', { section, index: 'new' })
    }, null)
  },
  peResidenceHistoriesCardCreate: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      post('/party_characteristics', {
        residence_histories: {
          party_id: party.id,
          address: section.address,
          county: section.county,
          start_date: section.start_date,
          start_date_format: section.start_date_format,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          non_us_data: section.non_us_data,
          city: section.city,
          state: section.state,
          zip: section.zip,
          int_state: section.int_state,
          int_zip: section.int_zip,
          country_id: section.country_id,
        },
      }).
      then(({ data }) => {
        commit('setPeResidenceHistoriesCardLock', { index: 'new', lock: true })
        commit('setPeResidenceHistoriesCardLock', { index: data.id, lock: true })
        commit('pePatchCharacteristicNew', {
          characteristic: 'residence_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peResidenceHistoriesCardRefresh: async ({ commit, getters }, { section, index }) => {
    const party = getters.peParty
    return axiosRequest.
      get(`/parties/${party.id}/party_characteristics/residence_histories/${section.id}`).
      then(({ data }) => {
        commit('setPeResidenceHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'residence_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peResidenceHistoriesCardUpdate: async ({ commit, getters }, { id, section, index }) => {
    const party = getters.peParty

    return axiosRequest.
      patch(`/party_characteristics/${id}`, {
        residence_histories: {
          party_id: party.id,
          address: section.address,
          county: section.county,
          start_date: section.start_date,
          start_date_format: section.start_date_format,
          start_date_uncertain: section.start_date_uncertain,
          end_date: section.end_date,
          end_date_format: section.end_date_format,
          end_date_uncertain: section.end_date_uncertain,
          non_us_data: section.non_us_data,
          city: section.city,
          state: section.state,
          zip: section.zip,
          int_state: section.int_state,
          int_zip: section.int_zip,
          country_id: section.country_id,
        },
        id,
      }).
      then(({ data }) => {
        commit('setPeResidenceHistoriesCardLock', { index, lock: true })
        commit('pePatchCharacteristic', {
          characteristic: 'residence_histories',
          value: data,
        })

        return data
      }).
      catch(handleError)
  },
  peResidenceHistoriesCardDelete: async ({ commit, getters }, { id, index }) => {
    const party = getters.peParty

    return axiosRequest.
      delete(`/party_characteristics/${id}`, {
        data: {
          residence_histories: {
            party_id: party.id,
          },
          id,
        },
      }).
      then(({ data }) => {
        const residenceHistories = data.residence_histories

        commit('setPeResidenceHistoriesCardLock', { index, lock: true })
        commit('pePatchParty', {
          residence_histories: residenceHistories || [],
        })
      }).
      catch(handleError)
  },
  peResidenceHistoriesCardAddSection: ({ commit }) => {
    commit('setPeResidenceHistoriesCardLock', { index: 'new', lock: false })
    commit('addPeResidenceHistoriesCardSection', {
      id: null,
      address: null,
      county: null,
      start_date: null,
      start_date_format: null,
      start_date_uncertain: null,
      end_date: null,
      end_date_format: null,
      end_date_uncertain: null,
      non_us_data: null,
      city: null,
      state: null,
      zip: null,
      int_state: null,
      int_zip: null,
      country_id: null,
    })
  },
}

export const PEResidenceHistoriesCardMutations = {
  setPeResidenceHistoriesCardLock: (state, { index, lock }) => {
    if (!state.partyEdit.partySections.ResidenceHistoriesCard) {
      Vue.set(state.partyEdit.partySections, 'ResidenceHistoriesCard', {})
    }
    Vue.set(state.partyEdit.partySections.ResidenceHistoriesCard, index, lock)
  },
  addPeResidenceHistoriesCardSection: (state, section) => {
    state.partyEdit.party.residence_histories.push(section)
  },
  peResidenceHistoriesCardCreateUndo: state => {
    state.partyEdit.party.residence_histories.pop()
    Vue.set(state.partyEdit.partySections.ResidenceHistoriesCard, 'new', true)
  },
}

export const PEResidenceHistoriesCardGetters = {
  peResidenceHistoriesCardLock: state => index => state.partyEdit.partySections.ResidenceHistoriesCard[index],
  peResidenceHistoriesCardHasNewSection: (_, getters) => !!getters.
    peParty.
    residence_histories?.
    find(language => language.id === null),
}
